import { FormDataType } from "DataTypes/Form";

export const FormDataArr: FormDataType[] = [
  {
    id: "practice",
    label: "Organization Name",
    placeholder: "Select Organization",
    boxType: "input-box",
    boxSize: 6,
    validatetype: "org-name",
    readOnly: true,
  },
  {
    id: "location",
    label: "Location Name",
    placeholder: "Select Location",
    boxType: "single-select-drop",
    dropArr: [],
    boxSize: 6,
    validatetype: "dropdown",
  },
];

export type SectionType =
  | "demographic"
  | "insurances"
  | "emergency-contacts"
  | "medications"
  | "problems"
  | "allergies"
  | "vitals"
  | "results"
  | "vaccines"

export const SectionsList: { id: SectionType, label: string }[] = [
  {
    id: "demographic",
    label: "Profile Section"
  },
  {
    id: "insurances",
    label: "Insurance"
  },
  {
    id: "emergency-contacts",
    label: "Emergency Contacts"
  },
  {
    id: "medications",
    label: "Medications"
  },
  {
    id: "problems",
    label: "Problems"
  },
  {
    id: "allergies",
    label: "Allergies"
  },
  {
    id: "vitals",
    label: "Vitals"
  },
  {
    id: "vaccines",
    label: "Vaccines"
  },
  {
    id: "results",
    label: "Results"
  },
]